<template>
  <div>
    <transition name="fade">
      <div class="modal__overlay" :key="1" v-if="active">
        <div  v-on-clickaway="closeModal" :key="3" :class="[{ active : active }, modalClass]">
          <v-button
            class="modal__close"
            icon="icon-close"
            icon-position="left"
            @click.native="closeModal"
          />
          <div class="modal__inner">
            <slot name="header"/>
            <div class="modal__content">
              <slot name="content"/>
            </div>
          </div>
          <slot name="footer"/>
        </div>
      </div>
    </transition>
    <!--<transition name="scale-fade">-->

    <!--</transition>-->
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
export default {
  name: 'Modal',
  mixins: [ clickaway ],
  props: {
    active: Boolean,
    modalClass: String
  },
  methods: {
    closeModal () {
      this.$emit('onModalClose')
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/modal";
</style>
